// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("flu:cart:item-added", function (evt) {
  //console.log("Item added to the cart", evt.detail.product);
});

function updateProgressBar(evt) {
  let innerHTML = "<p style=\"margin-bottom:5px;\">";
  if (evt.detail.cart.total_price >= 7500) {
    innerHTML += "Congrats! 🎉 You've got free shipping! 🎉";
  } else if (evt.detail.cart.total_price == 0) {
    innerHTML += "Orders over $75 ship free";
  } else if (evt.detail.cart.total_price < 7500) {
    innerHTML += `Add $${ (7500 - evt.detail.cart.total_price) / 100 } for free shipping`;
  }
  innerHTML += "</p>"

  const progBar = `$0 &nbsp;<progress max=\"7500\" value=\"${evt.detail.cart.total_price}\"></progress> &nbsp;$75`;

  // console.log("inner", innerHTML)
  //console.log("pro", progBar)

  document.getElementById("custom_progress-bar").innerHTML =
    innerHTML + progBar;
}

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("flu:cart:updated", function (evt) {
  // console.log("Cart updated", evt.detail.cart);

  //$('#custom_progress-bar').load('#custom_progress-bar > *')

  // var req = new XMLHttpRequest();
  // req.open("POST", "address_for_div_content", true);
  // req.onreadystatechange = function () {
  //   if (req.readyState != 4 || req.status != 200) return;
  //   document.getElementById('custom_progress-bar')=req.responseText;
  // };

  updateProgressBar(evt);
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("flu:cart:error", function (evt) {
  //console.log(evt.detail.errorMessage, "Cart error");
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("flu:quick-cart:open", function (evt) {
  //console.log("Quick cart opened", evt.detail.cart);
  updateProgressBar(evt);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("flu:quick-cart:close", function () {
  //console.log("Quick cart closed");
});

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("flu:product:variant-change", function (evt) {
  //console.log("Product variant changed", evt.detail.variant);
});

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("flu:product:quantity-update", function (evt) {
  //console.log("Product quantity updated", evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick shop' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
  //console.log("Quickview loaded");
});
